import { useEffect } from 'react';

const SCROLL_KEYS = [
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'PageUp',
  'PageDown',
  'Home',
  'End',
  ' ',
];

const isInsideDropdown = (target: EventTarget | null): boolean => {
  if (!(target instanceof Element)) return false;
  return !!target.closest(
    '[data-dropdown-root="true"], [data-testid="dropdown-options"]'
  );
};

export const useScrollLock = (locked: boolean) => {
  useEffect(() => {
    if (!locked) return;

    const preventDefault = (e: Event) => {
      if (isInsideDropdown(e.target)) return;
      e.preventDefault();
    };

    const preventDefaultForScrollKeys = (e: KeyboardEvent) => {
      if (isInsideDropdown(e.target)) return;
      if (SCROLL_KEYS.includes(e.key)) {
        e.preventDefault();
      }
    };

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    window.addEventListener('wheel', preventDefault, {
      passive: false,
    } as AddEventListenerOptions);
    window.addEventListener('touchmove', preventDefault, {
      passive: false,
    } as AddEventListenerOptions);

    window.addEventListener('keydown', preventDefaultForScrollKeys, {
      passive: false,
    } as AddEventListenerOptions);

    return () => {
      document.body.style.overflow = originalOverflow;
      window.removeEventListener('wheel', preventDefault);
      window.removeEventListener('touchmove', preventDefault);
      window.removeEventListener('keydown', preventDefaultForScrollKeys);
    };
  }, [locked]);
};
